require('./boots/less/bootstrap.less')
require('./font-awesome/css/font-awesome.css')

require('./animate/animate.css')
require('./toastr/toastr.css')
require('./datetimepicker/bootstrap-datetimepicker.min.css')
require('./tree-control/tree-control.css')
require('./chosen/chosen.css')
require('./select2/select2.css')
require('./select2/select2-bootstrap.css')
require('./angular-ui-tree/angular-ui-tree.css')
require('./sweetalert/sweetalert.css')
require('./layer/theme/default/layer.css')

require('./ztree/css/zTreeStyle/zTreeStyle.css')

// require("./unknown/global.css")
// require("./unknown/style.css")
// jquery
import $ from 'jquery'
window.$ = $
window.jQuery = $

require('./tax/MathContext.js')
require('./tax/BigDecimal.js')
require('./tax/TAX_CORE.js')

require('./sweetalert/sweetalert.min.js')
require('./select2/select2.js')
require('./layer/layer.js')
require('./datetimepicker/bootstrap-datetimepicker.js')
require('./datetimepicker/bootstrap-datetimepicker.zh-CN.js')

require('./boots/bootstrap.js')

require('./jqplugin/jquery.metisMenu.js')
require('./toastr/toastr.js')
require('./jqplugin/slimScroll.js')
require('./jqplugin/jquery-migrate-1.2.1.min.js')
require('./jqplugin/jquery.jqprint-0.3.js')
require('./jqplugin/jquery.jsonp-2.4.0.min')
require('./jqplugin/jquery.xdomainrequest.min.js')

require('./ztree/js/jquery.ztree.core.js')
require('./ztree/js/jquery.ztree.excheck.js')
require('./ztree/js/jquery.ztree.exhide.js')



// WEBPACK FOOTER //
// ./vendor/index.js